import React from 'react';
import { Connect, PropsFromRedux } from './SearchLeaveHandlerContainer';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';

type Props = PropsFromRedux;

export class RawSearchLeaveHandler extends React.Component<Props> {
  componentDidMount() {
    window.addEventListener(
      'beforeunload',
      this.addOriginalQueryKeyToUrlForBrowserHistory,
    );
  }

  componentWillUnmount() {
    window.removeEventListener(
      'beforeunload',
      this.addOriginalQueryKeyToUrlForBrowserHistory,
    );
  }

  addOriginalQueryKeyToUrlForBrowserHistory = () => {
    const { originalQueryKey } = this.props;
    if (originalQueryKey) {
      const replacedUrl = buildUrlWithParameters(window.location.href, {
        original_query_key: originalQueryKey,
      });
      window.history.replaceState({}, '', replacedUrl);
    }
  };

  render() {
    return null;
  }
}

export const SearchLeaveHandler = Connect(RawSearchLeaveHandler);
